import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AlertService } from 'services/alert.service';
import { DatePipe } from '@angular/common';
import { ApplicationService } from 'services/application.service';

@Component({
  selector: 'app-changerequestmodel',
  templateUrl: './changerequestmodel.component.html',
  styleUrls: ['./changerequestmodel.component.scss']
})
export class ChangeRequestModelComponent implements OnInit {
  form: FormGroup;

  value: any;
  min: Date;
  max: Date;
  productCost: string;

  public myFilter = (d: Date): boolean => {
    const date = d.getDate();
    this.form.value.changeRequestDate = this.transformDate(d);
    if (!this.data.isUpgrade) {
      return date == 1;
    }
    else {
      return date > 0;
    }
  }


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ChangeRequestModelComponent>,
    private navigationService: NavigationService,
    private userService: UserService,
    private applicationService: ApplicationService,
    private alertService: AlertService,
    private datePipe: DatePipe) {
    if (this.data) {
      this.value = JSON.stringify(data);
      this.productCost = "R " + this.data.cost + " Per Month"
    }
    this.initializeValidators();
  }

  ngOnInit() {
    var newDate = new Date();
    if (!this.data.isUpgrade) {
      newDate.setMonth(newDate.getMonth() + 2);
      var date = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
      this.min = date;
    }
    else {
      var date = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
      this.min = date;
    }

  }
  initializeValidators() {
    this.form = new FormGroup({
      changeRequestDate: new FormControl('', [Validators.required])
    });
  }

  onSave() {
    
    if (this.form.valid) {

      // let isTrueSet = (this.data.isUpgrade == 'true');

      let postDatas = {
        referenceNumber: this.data.applicationNo,
        cancellationDate: this.form.value.changeRequestDate,
        isUpgrade: this.data.isUpgrade
      }
      this.applicationService.saveCustomerChangeOfService(postDatas).subscribe(response => {
        if(!response){
          this.dialogRef.close();
          this.alertService.success("Cancellation Requested");
        }
        else
          {
            //this.showDetails = false;

            if(response.detail)
              this.alertService.warning(response.detail);

            else if(response)
              this.alertService.warning(response);
          }
      });

      // this.applicationService.saveCustomerChangeOfService(postDatas).subscribe(result => {

      //   if (result) {
      //     this.dialogRef.close();
      //     if (result.value > 0) {
      //       this.alertService.success('Your request has been added successfully');
      //     }
      //   }

      // });
    } else {
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
  onCancel() {
    this.dialogRef.close();
  }

  transformDate(date) {
    return this.datePipe.transform(date, 'yyyy/MM/dd');
  }


}
